// extracted by mini-css-extract-plugin
export default {"body":"Home_body__bI1fz","cellButton":"Home_cellButton__EDWvM","subBody":"Home_subBody__2B6-i","legend":"Home_legend__PBBLK","logo":"Home_logo__vR5+R"};